import React, { FC } from 'react'
import classNames from 'classnames'
import { Box, makeStyles, Typography } from 'transfix-ui/core'
import { calcRem, LabelComponent } from 'transfix-ui'

interface IFieldWrapperProps {
  title: string
  subtitle?: string
  required?: boolean
  className?: string
}

const useFieldWrapperStyles = makeStyles(theme => ({
  caption: theme.typography.caption,
  size: {
    fontSize: `${calcRem(14)} !important`,
    fontWeight: 'bold',
  },
}))

const FieldWrapper: FC<IFieldWrapperProps> = ({
  children,
  className,
  required = false,
  subtitle = '',
  title,
}) => {
  const classes = useFieldWrapperStyles()
  return (
    <Box className={className} mt={2}>
      <LabelComponent
        className={classNames(classes.caption, classes.size)}
        required={required}
        label={title}
      />
      {subtitle && <Typography variant='body1'>{subtitle}</Typography>}
      {children}
    </Box>
  )
}

export default FieldWrapper
